import { AdvancedMarker, useAdvancedMarkerRef } from '@vis.gl/react-google-maps'
import React, { useCallback } from 'react'

import Box from '@mui/material/Box'

// import Typography from '@mui/material/Typography'

const MapClusterMarker = ({
  position,
  size,
  sizeAsText,
  onClick,
  clusterId,
  theme,
}) => {
  const [markerRef, marker] = useAdvancedMarkerRef()
  const handleClick = useCallback(
    () => onClick && onClick(marker, clusterId),
    [onClick, marker, clusterId]
  )

  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      onClick={handleClick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          border: `1px solid ${theme.palette.primary.main}`,
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.contrastText,
          fontSize: '14px',
          width: 40,
          height: 40,
        }}
      >
        {sizeAsText}
      </Box>
    </AdvancedMarker>
  )
}

export default MapClusterMarker
